import {Injectable} from '@angular/core';
import i18next from 'i18next';
import {UploadFile} from './upload-file';

@Injectable({providedIn: 'root'})
export class FileUploadAnnouncerService {
    private lastMessage = '';
    private timer: number | null = null;

    announceUploadStatusChange(alertEl: HTMLElement, prev: UploadFile[], curr: UploadFile[]): void {
        for (let i = 0; i < curr.length; i++) {
            const file = curr[i];
            const prevFile = prev[i];

            const statusChanged = prevFile?.status !== file.status;
            const isFinalStatus = file.status === 'success' || file.status === 'error';

            if (!statusChanged || !isFinalStatus) continue;

            const message = [
                i18next.t(`sendmail.form.upload.status.${file.status}`),
                file.fileName,
                file.status === 'error' && file.errorKey ? i18next.t(file.errorKey) : null
            ]
                .filter(Boolean)
                .join(' ');

            this.announce(alertEl, message);
        }
    }

    announceFileDeleted(alertEl: HTMLElement, file: UploadFile): void {
        this.announce(alertEl, `${i18next.t('sendmail.form.upload.deleted')}: ${file.fileName}`);
    }

    private announce(alertEl: HTMLElement, message: string): void {
        const trimmed = (message ?? '').trim();
        if (!trimmed) return;

        if (trimmed === this.lastMessage) return;
        this.lastMessage = trimmed;

        if (this.timer !== null) {
            globalThis.clearTimeout(this.timer);
            this.timer = null;
        }

        alertEl.textContent = '';
        this.timer = globalThis.setTimeout(() => {
            alertEl.textContent = trimmed;
            this.timer = null;
        }, 300) as unknown as number;
    }
}